import React from 'react';
import { Check, ArrowRight, ShieldCheck, CreditCard, Smartphone } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferStackSection() {
  const offers = [{
    image: 'https://cdn.magicpatterns.com/uploads/wVRK9J8FPb4GXsuRe9s9aA/Masterkit_IA.jpg',
    title: '📘 MASTERKIT IA: El Sistema Completo',
    subtitle: 'La Guía Paso a Paso de 0 a Experto',
    value: '$47.00',
    description: 'No es un libro teórico. Es un sistema de implementación rápida para dominar la Inteligencia Artificial desde tu celular. Aprende a crear textos, imágenes y soluciones que clientes internacionales pagan en moneda fuerte.',
    features: ['Ingeniería de Prompts: Aprende a darle órdenes a la IA.', 'Creación automática de contenido, artículos y guiones.', 'Estrategias para ofrecer tus servicios desde cero.'],
    isBonus: false
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/u5oY4fxavRmGN1wZmJEkoc/Bono_1.png',
    title: '🎁 BONO 1: La Biblia de Prompts para Freelancers',
    subtitle: '50+ Comandos Listos para Copiar y Pegar',
    value: '$27.00',
    description: 'Deja de adivinar qué decirle al chat. Hemos creado la biblioteca definitiva de comandos para que generes trabajos de calidad profesional en segundos y los entregues a tus clientes.',
    features: ['Prompts para redactar artículos, emails y posts de redes.', 'Guiones exactos para cerrar ventas por WhatsApp.', 'Estructuras persuasivas para manejar objeciones.'],
    isBonus: true
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/1qHW5PTXMnNqdycr8kB5dZ/Bono_2.png',
    title: '🛠️ BONO 2: Toolbox Gratuita Anti-Bloqueos',
    subtitle: 'Las 20 Mejores Herramientas (100% Gratis)',
    value: '$19.00',
    description: 'No necesitas pagar suscripciones costosas. Curamos la lista definitiva de herramientas de IA gratuitas que funcionan perfecto con el internet de Venezuela y no piden tarjeta para registrarse.',
    features: ['Alternativas gratis y sin VPN a ChatGPT Plus y Midjourney.', 'Herramientas para crear logotipos y voces con IA.', 'Plataformas ligeras que abren súper rápido en el celular.'],
    isBonus: true
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/uL2ucBBgT4GNySLrMo8Lh9/Bono_3.png',
    title: '✅ BONO 3: Ruta de Monetización Rápida',
    subtitle: 'Paso a Paso para tu Primer Cliente Global',
    value: '$9.00',
    description: 'No te dejamos solo con la herramienta. Te damos la ruta exacta de 7 días para armar tu portafolio, encontrar personas buscando tus servicios y recibir tu primer pago desde el extranjero.',
    features: ['Dónde encontrar clientes internacionales de forma segura.', 'Qué decirles exactamente para que confíen en ti.', 'Cómo cobrar tus ganancias usando Binance o Zinli.'],
    isBonus: true
  }];
  return <section className="py-24 bg-[#050505] relative overflow-hidden border-t border-white/5" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        {/* Encabezado */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-189">
          <motion.h2 initial={{
          opacity: 0,
          y: -20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tight" data-id="element-190">
            TODO LO QUE{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-600" data-id="element-191">
              RECIBES HOY
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-400 font-light" data-id="element-192">
            Un arsenal digital valorado en{' '}
            <span className="text-red-400 line-through font-bold" data-id="element-193">$102</span>.
            Hoy te lo llevas por una fracción de ese precio.
          </motion.p>
        </div>

        {/* Lista de Productos (Stack) */}
        <div className="max-w-5xl mx-auto space-y-8 mb-16" data-id="element-194">
          {offers.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.1
        }} className={`relative rounded-3xl overflow-hidden border flex flex-col md:flex-row ${item.isBonus ? 'border-cyan-500/30 bg-gradient-to-r from-[#0a1628] to-[#050505] hover:border-cyan-500/50' : 'border-blue-500/50 bg-[#0f172a] shadow-2xl shadow-blue-900/20 hover:border-blue-400'} transition-colors duration-300`} data-id="element-195">
              {item.isBonus && <div className="absolute top-0 right-0 bg-cyan-600 text-white text-xs font-black px-4 py-1 rounded-bl-xl z-20 shadow-lg shadow-cyan-500/30 tracking-wider" data-id="element-196">
                  BONO DE REGALO
                </div>}

              <div className="w-full md:w-1/3 p-6 md:p-8 flex items-center justify-center bg-black/40" data-id="element-197">
                <div className="relative aspect-square md:aspect-[4/3] w-full max-w-[200px] md:max-w-none rounded-xl overflow-hidden bg-black/60 border border-white/10 group shadow-lg" data-id="element-198">
                  <img src={item.image} alt={item.title} className="w-full h-full object-contain p-2 group-hover:scale-105 transition-transform duration-500" data-id="element-199" />
                </div>
              </div>

              <div className="flex-1 p-6 md:p-8 pt-0 md:pt-8 text-left" data-id="element-200">
                <div className="flex flex-col md:flex-row justify-between items-start mb-4" data-id="element-201">
                  <div data-id="element-202">
                    <h3 className="text-2xl font-bold text-white mb-1" data-id="element-203">
                      {item.title}
                    </h3>
                    <p className="text-cyan-400 font-medium text-sm md:text-base" data-id="element-204">
                      {item.subtitle}
                    </p>
                  </div>

                  <div className="text-right hidden md:block min-w-[100px]" data-id="element-205">
                    <span className="block text-xs text-gray-500 uppercase font-bold" data-id="element-206">
                      Valor Real
                    </span>
                    <span className="text-xl font-bold text-red-400 line-through" data-id="element-207">
                      {item.value}
                    </span>
                  </div>
                </div>

                <p className="text-gray-300 mb-6 leading-relaxed text-sm md:text-base border-b border-white/10 pb-6" data-id="element-208">
                  {item.description}
                </p>

                <ul className="space-y-3" data-id="element-209">
                  {item.features && item.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-210">
                        <div className="mt-1 bg-cyan-500/20 p-1 rounded-full flex-shrink-0" data-id="element-211">
                          <Check className="w-3 h-3 text-cyan-400" data-id="element-212" />
                        </div>
                        <span className="text-gray-400 text-sm" data-id="element-213">{feature}</span>
                      </li>)}
                </ul>

                <div className="mt-6 flex items-center gap-2 md:hidden border-t border-white/5 pt-4" data-id="element-214">
                  <span className="text-sm text-gray-500 uppercase font-bold" data-id="element-215">
                    Valor Real:
                  </span>
                  <span className="text-lg font-bold text-red-400 line-through" data-id="element-216">
                    {item.value}
                  </span>
                  {item.isBonus && <span className="ml-auto text-cyan-400 font-black text-sm tracking-wider" data-id="element-217">
                      ¡HOY GRATIS!
                    </span>}
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* CTA FINAL OPTIMIZADO PARA VENEZUELA */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mt-12 flex flex-col items-center" data-id="element-218">
          {/* Caja Resumen de Valor */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-4 mb-6 backdrop-blur-sm max-w-md w-full" data-id="element-219">
            <div className="flex justify-between items-center text-gray-400 text-sm mb-2" data-id="element-220">
              <span data-id="element-221">Valor Total (Si compraras por separado):</span>
              <span className="line-through text-red-400 font-bold" data-id="element-222">
                $102.00
              </span>
            </div>
            <div className="flex justify-between items-center text-white text-lg font-black border-t border-white/10 pt-2 mt-2" data-id="element-223">
              <span data-id="element-224">Precio Único Hoy:</span>
              <span className="text-cyan-400" data-id="element-225">$14.99 USD</span>
            </div>
          </div>

          {/* BOTÓN DE COMPRA */}
          <div className="inline-block p-1 rounded-full bg-gradient-to-r from-green-400 via-cyan-500 to-blue-600 shadow-[0_0_40px_-10px_rgba(34,211,238,0.4)] w-full md:w-auto hover:shadow-[0_0_60px_-10px_rgba(34,211,238,0.6)] transition-shadow duration-500 animate-pulse" data-id="element-226">
            <a href="https://checkout.digitalsolvex.shop/cart/43743678496856:1?checkout" target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-227">
              <button className="px-8 py-4 rounded-full bg-white text-black font-black text-lg md:text-2xl transition-transform flex flex-col items-center justify-center gap-1 w-full md:w-auto cursor-pointer relative overflow-hidden group" data-id="element-228">
                <div className="flex items-center gap-3" data-id="element-229">
                  OBTENER ACCESO INMEDIATO
                  <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-230" />
                </div>
                <span className="text-sm md:text-base font-bold text-gray-700 bg-gray-100 px-3 py-1 rounded-full mt-1" data-id="element-231">
                  Paga $14.99 o Aprox. Bs. 7.150
                </span>
              </button>
            </a>
          </div>

          {/* TRUST BADGES PARA VENEZUELA (FUNDAMENTAL ANTES DEL CLIC) */}
          <div className="mt-8 flex flex-col items-center gap-3 w-full" data-id="element-232">
            <div className="flex flex-wrap justify-center gap-3 md:gap-4 text-sm w-full" data-id="element-233">
              <span className="flex items-center justify-center gap-2 text-green-400 bg-green-500/10 px-4 py-2 rounded-xl border border-green-500/30 flex-1 min-w-[140px] max-w-[200px]" data-id="element-234">
                <Smartphone className="w-5 h-5" data-id="element-235" /> Pago Móvil
              </span>
              <span className="flex items-center justify-center gap-2 text-yellow-400 bg-yellow-500/10 px-4 py-2 rounded-xl border border-yellow-500/30 flex-1 min-w-[140px] max-w-[200px]" data-id="element-236">
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" data-id="element-237">
                  <path d="M11.999 0L17.58 5.582l-2.028 2.028-3.553-3.553-3.553 3.553-2.028-2.028L11.999 0zm0 16.516l-4.516-4.516-2.028 2.028 6.544 6.544 6.544-6.544-2.028-2.028-4.516 4.516zm9.58-10.934l2.028 2.028-6.544 6.544-2.028-2.028 6.544-6.544zm-19.16 0l2.028-2.028 6.544 6.544-2.028 2.028-6.544-6.544z" data-id="element-238" />
                </svg>{' '}
                Binance Pay
              </span>
              <span className="flex items-center justify-center gap-2 text-blue-400 bg-blue-500/10 px-4 py-2 rounded-xl border border-blue-500/30 flex-1 min-w-[140px] max-w-[200px]" data-id="element-239">
                <CreditCard className="w-5 h-5" data-id="element-240" /> Tarjetas
              </span>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-center gap-2 text-gray-400 text-sm mt-4 bg-white/5 px-6 py-2 rounded-full" data-id="element-241">
              <ShieldCheck className="w-4 h-4 text-cyan-500" data-id="element-242" />
              <span data-id="element-243">Pago Único Seguro • Entrega Inmediata al Correo</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}